// extracted by mini-css-extract-plugin
export default {"wrapper":"Snackbar-wrapper___q+bxh","snackbar":"Snackbar-snackbar___1KbUC"};